import Box from "@/components/Box";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_PROMOS_QUERY } from "@/graphql/organisations/queries/promos";
import { useQuery } from "@apollo/client";

import DashboardPanel from "../DashboardPanel";
import NewsPromoList from "./NewsPromoList";
import {
  cmpHomeDashboardNarrowColumnWidth,
  cmpHomeDashboardNewsPromoLimit,
  cmpHomeDashboardPanelTitleProps,
  cmpHomeDashboardScrollableNewsListBoxProps,
  cmpHomeDashboardUniformPanelPadding
} from "./dashboardLayout";

export default function NewsPanel() {
  const { organisation } = useOrganisationContext();

  const { data, loading } = useQuery(CMP_PROMOS_QUERY, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-and-network",
    variables: {
      organisation: parseInt(organisation?.id, 10),
      limit: cmpHomeDashboardNewsPromoLimit
    },
    skip: !organisation?.id
  });

  const promos = data?.cmpPromos;

  return (
    <Box
      width="100%"
      maxWidth={["100%", "100%", cmpHomeDashboardNarrowColumnWidth]}
      flex="1 1 auto"
      minHeight={0}
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <DashboardPanel
        title="News"
        titleProps={cmpHomeDashboardPanelTitleProps}
        fillHeight
        padding={cmpHomeDashboardUniformPanelPadding}
        contentScrollProps={cmpHomeDashboardScrollableNewsListBoxProps}
      >
        <NewsPromoList promos={promos} loading={loading} />
      </DashboardPanel>
    </Box>
  );
}
